import { PropsWithChildren, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useUserStore } from 'src/context';
import { UserRole } from '/src/lib/types';

export type RequireAuthProps = PropsWithChildren & {
  /**
   * Roles allowed to view this route
   */
  allowedRoles?: UserRole[];
  /**
   * Route to redirect to if route is not allowed (defaults to `/signin`)
   */
  redirectUrl?: string;
  /**
   * Whether this route is a User Profile-related route
   */
  isUserRoute?: boolean;
};

export const RequireAuth: React.FC<RequireAuthProps> = observer(({ children, redirectUrl = '/signin' }) => {
  /** Context **/
  const userStore = useUserStore();
  const navigate = useNavigate();

  /** Effects **/
  useEffect(() => {
    if (!userStore.user) navigate(redirectUrl);
  }, [userStore.user]);

  return <>{children}</>;
});
